exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-dragLayer{font-size:1rem;display:flex;align-items:center;vertical-align:middle;padding:0 16px;z-index:9999999;position:fixed;margin-left:18px}.ba-common-dragLayer__nodrop{margin-left:-8px;margin-right:8px;position:relative}.bi--highContrast.ba-common-dragLayer{border:1px dotted transparent}.ba-common-dragLayer{background:#1f57a4;background:hsla(var(--primary1-h,214.73684),var(--primary1-s,68.20513%),var(--primary1-l,38.23529%),1);color:#fff;font-family:inherit}.ba-common-dragLayer__nodrop{color:#fff}", ""]);

// exports
exports.locals = {
	"dragLayerClassName": "\"ba-common-dragLayer\""
};